import { getField, updateField } from "vuex-map-fields";
import { statsService } from "../services";
import { EventBus } from "@/helpers";
import {
  CHART_TYPE,
  threshold_drone_hours,
  threshold_pilot_days
} from "../const";
import moment from "moment";
import { i18n } from "../main";

export const stats = {
  namespaced: true,
  state: {
    maxPilotCount: 0,
    pilotLabels: [],
    pilotSeries: [],

    maxDroneCount: 0,
    droneLabels: [],
    droneSeries: [],

    maxMissionCount: 0,
    missionLabels: [],
    missionSeries: [],

    totalMissions: 0,
    totalMissionsAll: 0,
    totalHours: 0,
    totalPilotHours: 0,

    pilotTotalMissions: [],
    pilotTotalMissionsAll: [],
    pilotCurrentDays: [],
    pilotNotificationCount: 0,
    pilotTotalHours: [],
    pilotHasMissions: false,
    pilotHasAllMissions: false,
    pilotHasHours: false,

    droneTotalHours: [],
    droneHasHours: false,
    droneCurrentHours: [],

    droneNotificationCount: 0
  },
  actions: {
    getCharts(context, payload) {
      return statsService
        .getCharts(payload.type, payload.startTime, payload.endTime)
        .then(response => {
          console.log(response);
          context.commit("setCharts", {
            type: payload.type,
            response: response
          });
        })
        .catch(error => {
          console.log("Error getCharts: ", error);
          EventBus.$emit("failedGetCharts", error);
        });
    },
    getMilestone(context, payload) {
      return statsService
        .getMilestone(payload)
        .then(response => {
          //console.log(response);
          context.commit("setMilestone", {
            response: response
          });
        })
        .catch(error => {
          console.log("Error getMilestone: ", error);
          EventBus.$emit("failedGetMilestone", error);
        });
    },
    getPilotTotalMissions(context, payload) {
      return statsService
        .getPilotTotalMissions(payload)
        .then(response => {
          //console.log(response);
          context.commit("setPilotTotalMissions", {
            response: response
          });
        })
        .catch(error => {
          console.log("Error getPilotTotalMissions: ", error);
          EventBus.$emit("failedGetPilotTotalMissions", error);
        });
    },
    getPilotTotalMissionsAll(context, payload) {
      return statsService
        .getPilotTotalMissionsAll(payload)
        .then(response => {
          //console.log(response);
          context.commit("setPilotTotalMissionsAll", {
            response: response
          });
        })
        .catch(error => {
          console.log("Error getPilotTotalMissionsAll: ", error);
          EventBus.$emit("failedGetPilotTotalMissionsAll", error);
        });
    },
    getPilotRangeTotalMissions(context, payload) {
      return statsService
        .getPilotRangeTotalMissions(payload.startTime, payload.endTime)
        .then(response => {
          //console.log(response);
          context.commit("setPilotRangeTotalMissions", {
            response: response
          });
        })
        .catch(error => {
          console.log("Error getPilotRangeTotalMissions: ", error);
          EventBus.$emit("failedGetPilotRangeTotalMissions", error);
        });
    },
    getPilotRangeTotalMissionsAll(context, payload) {
      return statsService
        .getPilotRangeTotalMissionsAll(payload.startTime, payload.endTime)
        .then(response => {
          //console.log(response);
          context.commit("setPilotRangeTotalMissionsAll", {
            response: response
          });
        })
        .catch(error => {
          console.log("Error getPilotRangeTotalMissionsAll: ", error);
          EventBus.$emit("failedGetPilotRangeTotalMissionsAll", error);
        });
    },
    getPilotTotalHours(context, payload) {
      return statsService
        .getPilotTotalHours(payload)
        .then(response => {
          //console.log(response);
          context.commit("setPilotTotalHours", {
            response: response
          });
        })
        .catch(error => {
          console.log("Error getPilotTotalHours: ", error);
          EventBus.$emit("failedGetPilotTotalHours", error);
        });
    },
    getPilotRangeTotalHours(context, payload) {
      return statsService
        .getPilotRangeTotalHours(payload.startTime, payload.endTime)
        .then(response => {
          //console.log(response);
          context.commit("setPilotRangeTotalHours", {
            response: response
          });
        })
        .catch(error => {
          console.log("Error getPilotRangeTotalHours: ", error);
          EventBus.$emit("failedGetPilotRangeTotalHours", error);
        });
    },
    getPilotCurrentDays(context, payload) {
      return statsService
        .getPilotCurrentDays(payload)
        .then(response => {
          //console.log(response);
          context.commit("setPilotCurrentDays", {
            response: response
          });
        })
        .catch(error => {
          console.log("Error getPilotCurrentDays: ", error);
          EventBus.$emit("failedGetPilotCurrentDays", error);
        });
    },
    getDroneTotalHours(context, payload) {
      return statsService
        .getDroneTotalHours(payload)
        .then(response => {
          //console.log(response);
          context.commit("setDroneTotalHours", {
            response
          });
        })
        .catch(error => {
          console.log("Error getDroneTotalHours: ", error);
          EventBus.$emit("failedGetDroneTotalHours", error);
        });
    },
    getDroneRangeTotalHours(context, payload) {
      return statsService
        .getDroneRangeTotalHours(payload.startTime, payload.endTime)
        .then(response => {
          //console.log(response);
          context.commit("setDroneRangeTotalHours", {
            response
          });
        })
        .catch(error => {
          console.log("Error getDroneRangeTotalHours: ", error);
          EventBus.$emit("failedGetDroneRangeTotalHours", error);
        });
    },
    getDroneCurrentHours(context, payload) {
      return statsService
        .getDroneCurrentHours(payload)
        .then(response => {
          console.log(response);
          context.commit("setDroneCurrentHours", {
            response
          });
        })
        .catch(error => {
          console.log("Error getDroneCurrentHours: ", error);
          EventBus.$emit("failedGetDroneCurrentHours", error);
        });
    }
  },
  mutations: {
    updateField,
    setCharts(state, payload) {
      console.log("setCharts:", payload.response);
      if (!payload.response) {
        return;
      }
      var list = JSON.parse(payload.response.data);
      var keys = [];
      var values = [];
      if (payload.type === CHART_TYPE.MISSION) {
        var incomplete = 0;
        var completed = 0;
        var aborted = 0;
        list.forEach(mission => {
          if (mission._id.aborted) {
            aborted = mission.count;
          } else if (mission._id.completed) {
            completed = mission.count;
          } else {
            incomplete = mission.count;
          }
        });
        state.maxMissionCount = Math.max(completed, incomplete, aborted);
        state.missionLabels = [
          i18n.t("checklist completed"),
          i18n.t("checklist in progress"),
          i18n.t("aborted")
        ];
        state.missionSeries = [completed, incomplete, aborted];
      } else if (payload.type === CHART_TYPE.PILOT) {
        list.forEach(pilot => {
          keys.push(pilot._id.pilot);
          values.push(pilot.count);
        });
        state.maxPilotCount = Math.max(...values);
        state.pilotLabels = [...keys];
        state.pilotSeries = [...values];
      } else {
        list.forEach(drone => {
          keys.push(drone._id.rpas);
          values.push(drone.count);
        });
        state.maxDroneCount = Math.max(...values);
        state.droneLabels = [...keys];
        state.droneSeries = [...values];
      }
      EventBus.$emit("setCharts", payload.type);
    },
    setMilestone(state, payload) {
      console.log("setMilestone:", payload);
      if (payload) {
        var result = JSON.parse(payload.response.data);
        state.totalMissions = result[0].missions;
        state.totalHours = result[1].hours;
      }
    },
    setPilotTotalMissions(state, payload) {
      console.log("setPilotMissions:", payload);
      state.pilotTotalMissions = JSON.parse(payload.response.data);
      state.pilotHasMissions = true;
    },
    setPilotTotalMissionsAll(state, payload) {
      console.log("setPilotMissionsAll:", payload);
      state.pilotTotalMissionsAll = JSON.parse(payload.response.data);
      state.pilotHasAllMissions = true;
    },
    setPilotRangeTotalMissions(state, payload) {
      if (payload && !payload.response.data.error) {
        console.log("setPilotRangeMissions:", payload);
        state.pilotTotalMissions = JSON.parse(payload.response.data);
        state.pilotHasMissions = true;
      } else {
        console.log("setPilotRangeMissions:   No Data");
        state.pilotTotalMissions = [];
        state.pilotHasMissions = false;
      }
    },
    setPilotRangeTotalMissionsAll(state, payload) {
      if (payload && !payload.response.data.error) {
        console.log("setPilotRangeMissionsAll:", payload);
        state.pilotTotalMissionsAll = JSON.parse(payload.response.data);
        state.pilotHasAllMissions = true;
      } else {
        console.log("setPilotRangeMissionsAll:   No Data");
        state.pilotTotalMissionsAll = [];
        state.pilotHasAllMissions = false;
      }
    },
    setPilotTotalHours(state, payload) {
      console.log("setPilotTotalHours:", payload);
      state.pilotTotalHours = JSON.parse(payload.response.data);
      state.pilotHasHours = true;
    },
    setPilotRangeTotalHours(state, payload) {
      if (payload && !payload.response.data.error) {
        console.log("setPilotRangeTotalHours:", payload);
        state.pilotTotalHours = JSON.parse(payload.response.data);
        state.pilotHasHours = true;
      } else {
        console.log("setPilotRangeTotalHours:   No Data");
        state.pilotTotalHours = [];
        state.pilotHasHours = false;
      }
    },
    setPilotCurrentDays(state, payload) {
      console.log("setPilotCurrentDays:", payload);
      if (payload) {
        state.pilotCurrentDays = JSON.parse(payload.response.data);
        state.pilotNotificationCount = 0;
        this.state.setting.pilots.forEach(pilot => {
          if (pilot.pilot) {
            if (!pilot.threshold) {
              pilot.threshold = threshold_pilot_days;
            }
            var match = state.pilotCurrentDays.find(
              item => item._id.license === pilot.license
            );
            if (
              match &&
              parseInt(
                moment
                  .duration(moment().diff(moment(match.last_mission.$date)))
                  .asDays()
              ) >= pilot.threshold
            ) {
              state.pilotNotificationCount++;
            }
          }
        });
      }
    },
    setDroneTotalHours(state, payload) {
      console.log("setDroneTotalHours:", payload);
      if (payload) {
        state.droneTotalHours = JSON.parse(payload.response.data);
        state.droneHasHours = true;
      }
    },
    setDroneRangeTotalHours(state, payload) {
      if (payload && !payload.response.data.error) {
        console.log("setDroneRangeTotalHours:", payload);
        state.droneTotalHours = JSON.parse(payload.response.data);
        state.droneHasHours = true;
      } else {
        console.log("setDroneRangeTotalHours:   No Data");
        state.droneTotalHours = [];
        state.droneHasHours = false;
      }
    },
    setDroneCurrentHours(state, payload) {
      console.log("setDroneCurrentHours:", payload);
      if (payload) {
        state.droneCurrentHours = JSON.parse(payload.response.data);
        state.droneNotificationCount = 0;
        this.state.setting.drones.forEach(drone => {
          if (drone.registrationnumber !== "") {
            if (!drone.threshold) {
              drone.threshold = threshold_drone_hours;
            }
            var match = state.droneCurrentHours.find(
              item => item._id.drone === drone.registrationnumber
            );
            if (match && match.hours >= drone.threshold) {
              state.droneNotificationCount++;
            }
          }
        });
      }
    }
  },
  getters: {
    getField
  }
};
